<!-- <p>login-screen-dialog works!</p> -->

<mat-dialog-content class="mat-typography">
  <div
    [ngClass]="{
      'login-form-container':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'login-form-container-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <mat-card class="login-card">
      <mat-progress-bar
        *ngIf="commonData?.status.isFetchingAPIRequest"
        mode="indeterminate"
      ></mat-progress-bar>
      <mat-card-header class="login-card-header"> Host Login </mat-card-header>
      <mat-card-content class="login-card-content">
        <mat-tab-group
          (selectedTabChange)="onChangeTab($event)"
          class="login-card-content-admin-tab"
          animationDuration="500ms"
        >
          <mat-tab label="Admin Login" class="admin-tab">
            <div
              [ngClass]="{
                'form-container':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'form-container-mobile': screenSize == ScreenType.Mobile
              }"
            >
              <div>
                <form
                  [ngClass]="{
                    'login-form':
                      screenSize == ScreenType.Desktop ||
                      screenSize == ScreenType.Tablet,
                    'login-form-mobile': screenSize == ScreenType.Mobile
                  }"
                  [formGroup]="adminFormGroup"
                >
                  <mat-form-field
                    appearance="outline"
                    class="login-form-field"
                    hideRequiredMarker
                  >
                    <mat-label>Account ID</mat-label>
                    <input
                      autocomplete="off"
                      maxlength="8"
                      (keypress)="inputValidator($event)"
                      formControlName="AccountID"
                      matInput
                      type="text"
                      [value]="adminFormGroup.value.AccountID"
                    />
                    <mat-error
                      class="login-mat-error"
                      *ngIf="adminFormGroup.controls.AccountID.errors?.['pattern']"
                      >Please enter valid data</mat-error
                    >
                    <!-- <mat-error
                          class="login-mat-error"
                          *ngIf="adminFormGroup.controls.AccountID.errors?.['required']"
                          >Please enter the &nbsp;<strong>
                            Credentials</strong
                          ></mat-error
                        > -->
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="login-form-field"
                    hideRequiredMarker
                  >
                    <mat-label>Account Pin</mat-label>
                    <input
                      autocomplete="off"
                      maxlength="5"
                      (keypress)="inputValidator($event)"
                      formControlName="PIN"
                      matInput
                      [type]="hide ? 'password' : 'text'"
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      (click)="hide = !hide"
                      [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hide"
                    >
                      <mat-icon>{{
                        hide ? "visibility_off" : "visibility"
                      }}</mat-icon>
                    </button>
                    <mat-hint
                      *ngIf=" (adminFormGroup.controls.AccountID.touched && adminFormGroup.controls.AccountID.errors?.['required'] )|| (adminFormGroup.controls.PIN.touched && adminFormGroup.controls.PIN.errors?.['required'] ) "
                      style="color: red; text-align: center; width: 100%"
                      >Please enter the
                      <strong> Admin Credentials</strong></mat-hint
                    >
                  </mat-form-field>
                </form>
                <div
                  *ngIf="commonData?.login?.errorMessage"
                  class="login-error-container"
                >
                  <button class="buttonClass" mat-raised-button>
                    {{ commonData?.login?.errorMessage }}
                  </button>
                </div>
                <div class="login-button-container">
                  <button
                    [disabled]="adminFormGroup.invalid"
                    (click)="onLogin()"
                    class="buttonClass"
                    [ngStyle]="
                      commonData?.status.isFetchingAPIRequest
                        ? { background: '#FEF5F9' }
                        : {}
                    "
                    mat-raised-button
                  >
                    {{
                      commonData?.status.isFetchingAPIRequest ? "" : "Log In"
                    }}
                    <mat-icon *ngIf="commonData?.status.isFetchingAPIRequest"
                      ><mat-spinner
                        class="button-spinner"
                        color="accent"
                        diameter="40"
                      >
                      </mat-spinner
                    ></mat-icon>
                  </button>
                </div>
                <div *ngIf="false" class="login-forgot-credential">
                  <a href="">Forget Credentials?</a>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="User Login">
            <div
              [ngClass]="{
                'form-container':
                  screenSize == ScreenType.Desktop ||
                  screenSize == ScreenType.Tablet,
                'form-container-mobile': screenSize == ScreenType.Mobile
              }"
            >
              <div>
                <form
                  [ngClass]="{
                    'login-form':
                      screenSize == ScreenType.Desktop ||
                      screenSize == ScreenType.Tablet,
                    'login-form-mobile': screenSize == ScreenType.Mobile
                  }"
                  [formGroup]="userFormGroup"
                >
                  <mat-form-field
                    appearance="outline"
                    class="login-form-field"
                    hideRequiredMarker
                  >
                    <mat-label>Email</mat-label>
                    <input
                      formControlName="Email"
                      matInput
                      type="email"
                      [value]="userFormGroup.value.Email"
                    />
                    <mat-error
                      class="login-mat-error"
                      *ngIf="userFormGroup.controls.Email.errors?.['email']"
                      >Enter a &nbsp;<strong>valid Email</strong>
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    hideRequiredMarker
                    class="login-form-field"
                  >
                    <mat-label>Password</mat-label>
                    <input
                      autocomplete="off"
                      matInput
                      formControlName="Password"
                      [type]="hide ? 'password' : 'text'"
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      (click)="hide = !hide"
                      [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hide"
                    >
                      <mat-icon>{{
                        hide ? "visibility_off" : "visibility"
                      }}</mat-icon>
                    </button>
                    <mat-hint
                      *ngIf=" (userFormGroup.controls.Password.touched && userFormGroup.controls.Password.errors?.['required'] )|| (userFormGroup.controls.Email.touched && userFormGroup.controls.Email.errors?.['required'] ) "
                      style="color: red; text-align: center; width: 100%"
                      >Please enter the
                      <strong> User Credentials</strong></mat-hint
                    >
                  </mat-form-field>
                </form>
              </div>
              <div
                *ngIf="commonData?.login?.errorMessage"
                class="login-error-container"
              >
                <button class="buttonClass" mat-raised-button>
                  {{ commonData?.login?.errorMessage }}
                </button>
              </div>
              <div class="login-button-container">
                <button
                  [disabled]="userFormGroup.invalid"
                  (click)="onLogin()"
                  class="buttonClass"
                  [ngStyle]="
                    commonData?.status.isFetchingAPIRequest
                      ? { background: '#FEF5F9' }
                      : {}
                  "
                  mat-raised-button
                >
                  {{ commonData?.status.isFetchingAPIRequest ? "" : "Log In" }}
                  <mat-icon *ngIf="commonData?.status.isFetchingAPIRequest"
                    ><mat-spinner
                      class="button-spinner"
                      color="accent"
                      diameter="40"
                    >
                    </mat-spinner
                  ></mat-icon>
                </button>
              </div>
              <div *ngIf="false" class="login-forgot-credential">
                <a href="">Forget Password?</a>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
      <mat-card-actions class="login-card-actions">
        <!-- <div
              (click)="onNewUserRegis()"
              class="flex--row-center new-user-button fs-14 push--bottom"
              *ngIf="true"
            >
              <button mat-raised-button>New User</button>
            </div> -->
      </mat-card-actions>
    </mat-card>
  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
  <button
    [disabled]="!selectedOption"
    mat-raised-button
    [mat-dialog-close]="selectedOption"
  >
    Save
  </button>
</mat-dialog-actions> -->
